@if (contracts | filterInfos: store.homeFilterText; as filteredContracts) {
  <mat-chip-set>
    @for (chip of searchContractsService.selectedFilters | keyvalue; track chip.key) {
      <div>
        @if (chip.value) {
          <mat-chip color="accent" highlighted removable (removed)="removeChip(chip.key)">
            {{ chip.value | formatChip: chip.key }}
            <mat-icon matChipRemove svgIcon="close"></mat-icon>
          </mat-chip>
        }
      </div>
    }
  </mat-chip-set>
  <div class="contracts-list">
    @if (isRecentlyConsulted) {
      <div class="recently-consulted">
        <mat-icon svgIcon="history"></mat-icon>
        {{ "publist.recentlyConsulted" | translate }}
      </div>
    } @else {
      <div class="contracts-count">
        {{ "home.count.contracts" | translate: { number: filteredContracts.length } }}
      </div>
    }
    @for (contract of filteredContracts; track contract.uidAhead) {
      <o-card-contract [contract]="contract"></o-card-contract>
    }
  </div>
} @else {
  <o-loading [isLoading]="true"></o-loading>
}
